import React from "react";
import axios from "axios";

//Matrial-ui core
import { CircularProgress, Dialog, DialogContent, DialogTitle, Slide } from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "tss-react/mui";

//Core items
import Button from "../../../components/CustomButtons/Button";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Detail extends React.Component {
  state = {
    callbacklog: {},
    loading: true,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.open && prevProps.open !== this.props.open) {
      this.loadApiLog();
    }

    if (this.props.open === false && prevProps.open !== this.props.open) {
      this.setState({ loading: true });
    }
  }

  isJsonString(inputData) {
    try {
      JSON.parse(inputData);
    } catch (e) {
      return false;
    }
    return true;
  }

  loadApiLog = () => {
    axios.get("core/callbacklog/" + this.props.callbacklogId).then((response) => {
      try {
        if (this.isJsonString(response.data.data.headers)) {
          response.data.data.headers = JSON.stringify(JSON.parse(response.data.data.headers), null, 2);
        }
        if (this.isJsonString(response.data.data.response)) {
          response.data.data.response = JSON.stringify(JSON.parse(response.data.data.response), null, 2);
        }
        this.setState({ callbacklog: response.data.data, loading: false });
      } catch (e) {
        this.setState({ callbacklog: response.data.data, loading: false });
      }
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth={true}
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
        scroll={"paper"}
      >
        <div>
          <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
            <Button
              aria-label={"Close"}
              className={classes.modalCloseButton}
              color={"transparent"}
              justIcon
              key={"close"}
              onClick={this.props.toggle}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>
              <TranslationWrapper tDefault={"Details van callbacklog"} tKey={"callbacklog.modal.detail.title"} /> #
              {this.state.callbacklog.id}
            </h4>
          </DialogTitle>
          {!this.state.loading ? (
            <div>
              <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
                <textarea
                  defaultValue={
                    this.state.callbacklog.http_method +
                    "\n" +
                    this.state.callbacklog.headers +
                    "\n" +
                    this.state.callbacklog.response
                  }
                  disabled
                  style={{ width: "100%", minHeight: "500px", height: "100%" }}
                />
              </DialogContent>
            </div>
          ) : (
            <div style={{ margin: "25px auto" }}>
              <CircularProgress />
            </div>
          )}
        </div>
      </Dialog>
    );
  }
}

export default withStyles(Detail, notificationsStyle);
